"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildBreedCharacteristic = exports.ParentBreedCharacteristic = void 0;
var ParentBreedCharacteristic;
(function (ParentBreedCharacteristic) {
    ParentBreedCharacteristic["UNKNOWN"] = "UNKNOWN";
    ParentBreedCharacteristic["ADAPTABILITY"] = "ADAPTABILITY";
    ParentBreedCharacteristic["ALL_AROUND_FRIENDLINESS"] = "ALL_AROUND_FRIENDLINESS";
    ParentBreedCharacteristic["HEALTH_GROOMING"] = "HEALTH_GROOMING";
    ParentBreedCharacteristic["TRAINABILITY"] = "TRAINABILITY";
    ParentBreedCharacteristic["EXERCISE_NEEDS"] = "EXERCISE_NEEDS";
})(ParentBreedCharacteristic = exports.ParentBreedCharacteristic || (exports.ParentBreedCharacteristic = {}));
var ChildBreedCharacteristic;
(function (ChildBreedCharacteristic) {
    ChildBreedCharacteristic["UNKNOWN"] = "UNKNOWN";
    // ADAPTABILITY
    ChildBreedCharacteristic["ADAPTS_WELL_TO_APARTMENT_LIVING"] = "ADAPTS_WELL_TO_APARTMENT_LIVING";
    ChildBreedCharacteristic["GOOD_FOR_NOVICE_OWNERS"] = "GOOD_FOR_NOVICE_OWNERS";
    ChildBreedCharacteristic["SENSITIVITY_LEVEL"] = "SENSITIVITY_LEVEL";
    ChildBreedCharacteristic["TOLERATES_BEING_ALONE"] = "TOLERATES_BEING_ALONE";
    ChildBreedCharacteristic["TOLERATES_COLD_WEATHER"] = "TOLERATES_COLD_WEATHER";
    ChildBreedCharacteristic["TOLERATES_HOT_WEATHER"] = "TOLERATES_HOT_WEATHER";
    // FRIENDLINESS
    ChildBreedCharacteristic["AFFECTIONATE_WITH_FAMILY"] = "AFFECTIONATE_WITH_FAMILY";
    ChildBreedCharacteristic["INCREDIBLY_KID_FRIENDLY_DOGS"] = "INCREDIBLY_KID_FRIENDLY_DOGS";
    ChildBreedCharacteristic["DOG_FRIENDLY"] = "DOG_FRIENDLY";
    ChildBreedCharacteristic["FRIENDLY_TOWARD_STRANGERS"] = "FRIENDLY_TOWARD_STRANGERS";
    // HEALTH & GROOMING
    ChildBreedCharacteristic["AMOUNT_OF_SHEDDING"] = "AMOUNT_OF_SHEDDING";
    ChildBreedCharacteristic["DROOLING_POTENTIAL"] = "DROOLING_POTENTIAL";
    ChildBreedCharacteristic["EASY_TO_GROOM"] = "EASY_TO_GROOM";
    ChildBreedCharacteristic["GENERAL_HEALTH"] = "GENERAL_HEALTH";
    ChildBreedCharacteristic["POTENTIAL_FOR_WEIGHT_GAIN"] = "POTENTIAL_FOR_WEIGHT_GAIN";
    ChildBreedCharacteristic["SIZE"] = "SIZE";
    // TRAINABILITY
    ChildBreedCharacteristic["EASY_TO_TRAIN"] = "EASY_TO_TRAIN";
    ChildBreedCharacteristic["INTELLIGENCE"] = "INTELLIGENCE";
    ChildBreedCharacteristic["POTENTIAL_FOR_MOUTHINESS"] = "POTENTIAL_FOR_MOUTHINESS";
    ChildBreedCharacteristic["PREY_DRIVE"] = "PREY_DRIVE";
    ChildBreedCharacteristic["TENDENCY_TO_BARK_OR_HOWL"] = "TENDENCY_TO_BARK_OR_HOWL";
    ChildBreedCharacteristic["WANDERLUST_POTENTIAL"] = "WANDERLUST_POTENTIAL";
    // EXERCISE_NEEDS
    ChildBreedCharacteristic["ENERGY_LEVEL"] = "ENERGY_LEVEL";
    ChildBreedCharacteristic["INTENSITY"] = "INTENSITY";
    ChildBreedCharacteristic["EXERCISE_NEEDS"] = "EXERCISE_NEEDS";
    ChildBreedCharacteristic["POTENTIAL_FOR_PLAYFULNESS"] = "POTENTIAL_FOR_PLAYFULNESS";
})(ChildBreedCharacteristic = exports.ChildBreedCharacteristic || (exports.ChildBreedCharacteristic = {}));
